import React, { useEffect, useState } from 'react'
import Grid from "@mui/material/Grid2";
import './styles.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { tableStyles } from 'src/shared/util/tableStyles';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PageviewIcon from '@mui/icons-material/Pageview';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Badge, Box, Button, CircularProgress, FormControl, IconButton, InputLabel, Link, MenuItem, Select, Tooltip, Typography, Dialog, DialogTitle, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { uploadActivitiesFromMobile, uploadImages, uploadSingleImage } from 'src/shared/util/updateDataServer';
import Swal from 'sweetalert2';
import UploadIcon from "@mui/icons-material/Upload";



export const BackupMobile = () => {

    const [loading, setLoading] = useState(false)

    const [file, setFile] = React.useState<File | null>(null);

    const [tabs, setTabs] = useState([
        { id: "activities", name: "Actividades", amountElement: 0 },
        { id: "pictures", name: "Fotos", amountElement: 0 },
        { id: "vehicleOverview", name: "Gerenciamiento", amountElement: 0 },
    ])

    const [vehicleOverview, setVehicleOverview] = useState<any>()

    const [activities, setActivities] = useState<any[]>([])

    const [imagesOfActivities, setImagesOfActivities] = useState<any[]>([])

    const [activeTab, setActiveTab] = useState(tabs[0].id)

    const [previewActivity, setPreviewActivity] = useState<any>(undefined)

    const [previewImage, setPreviewImage] = useState<any>(undefined);

    const handleOpenImagePreview = (image: any) => {
        setPreviewImage(image);
    };

    const handleCloseImagePreview = () => setPreviewImage(undefined);

    const navigate = useNavigate();

    useEffect(() => {
        console.log({ imagesOfActivities })
    }, [imagesOfActivities])


    const handleOnGoback = () => {
        navigate(-1);
    }

    const handleDelteFile = () => {
        setFile(null);
    }

    const handleTestFile = async () => {
        if (!file) return;
        setLoading(true);

        try {
            const text = await file.text(); // Read file as text
            const jsonData = JSON.parse(text); // Parse JSON

            console.log({ jsonData });

            const activities: any[] = []

            const pictures: any[] = []

            for (const activity of jsonData.activities) {

                const originActivity = {
                    ...activity,
                }

                delete originActivity.images

                const users = JSON.parse(activity.users || "[]")

                const location = activity?.variables?.find((v: any) => v.id === "name")?.value || "Sin Locacion"

                const estadoOpeFinal = activity?.variables?.find((v: any) => v.id === "ad664c23-960c-4c32-a01a-6c4d52593ff9")?.value || ""

                const horaInicio = activity?.variables?.find((v: any) => v.id === "cd1e06fc-016e-424e-a69a-aa82317ec742")?.value || ""

                const horaFin = activity?.variables?.find((v: any) => v.id === "987f2fce-1778-4e8c-afeb-a14c5bcffb84")?.value || ""

                const activityToPush = {
                    id: activity.id,
                    location,
                    estadoOpeFinal,
                    fecha: moment(activity.executedDate).format("DD/MM/YYYY"),
                    realizadaPor: users?.map((u: any) => u.fullName).join(", ") || "Sin Usuario",
                    hora: `${horaInicio} - ${horaFin}`,
                    originActivity,
                }

                activities.push(activityToPush)

                let counter = 1;

                if (Array.isArray(activity?.images?.value)) {
                    for (const image of activity?.images?.value) {
                        pictures.push({
                            ...activity?.variables,
                            ...image,
                            location,
                            counter,
                            activityId: activity.id,
                            executedAt: activity.executedDate,
                            locationdId: activity.locationId,
                            fieldId: activity.fieldId,
                        })
                        counter++;
                    }
                }

            }

            if (jsonData.vehicleOverview) {
                setVehicleOverview(jsonData.vehicleOverview)
            }


            setActivities(activities)
            setImagesOfActivities(pictures)


        } catch (error) {
            console.error("Error al leer o parsear el archivo:", error);
            alert("El archivo no es un JSON válido.");
        } finally {
            setLoading(false);
        }
    };


    const handlePreviewActivity = (activityId: string) => {
        const activity = activities.find(a => a.id === activityId);
        let variables = activity ? activity.originActivity?.variables : [];
        setPreviewActivity({
            ...activity, variables
        });
    }

    const handleClosePreview = () => setPreviewActivity(undefined);

    const getImageSrc = (image: any) => {
        if (!image) return "";
        // ya viene como data url
        if (typeof image.base64 === "string" && image.base64.startsWith("data:")) return image.base64;

        // si tienes la base64 en image.base64 (sin prefijo) -> construir data:url
        const base64 = image.base64 || image.data || null;
        if (base64) {
            const type = image.type
                || (image.fileName && image.fileName.toLowerCase().endsWith(".png") ? "image/png"
                    : image.fileName && /\.(jpe?g|jpg)$/i.test(image.fileName) ? "image/jpeg"
                        : "image/jpeg");
            // quitar saltos de linea por si acaso
            const cleaned = base64.replace(/\s/g, "");
            return `data:${type};base64,${cleaned}`;
        }

        // si es una url http/https
        if (typeof image.url === "string") return image.url;

        return "";
    };

    const onDownloadImages = async () => {
        if (!imagesOfActivities || imagesOfActivities.length === 0) return;
        setLoading(true);
        try {
            const zip = new JSZip();

            const promises = imagesOfActivities.map(async (image: any, idx: number) => {
                try {
                    const src = getImageSrc(image);
                    if (!src) return;

                    // fetch works with data: urls and http(s) urls
                    const resp = await fetch(src);
                    if (!resp.ok) throw new Error(`Failed fetching image ${idx}`);

                    const blob = await resp.blob();
                    // determine extension from blob.type
                    const mime = blob.type || "image/jpeg";
                    const ext = mime.split("/")[1] ? mime.split("/")[1].split("+")[0] : "jpg";

                    // filename fallback
                    const baseName = image.fileName
                        ? image.fileName.replace(/\.[^/.]+$/, "")
                        : image.location
                            ? `${image.location}_${image.counter}`
                            : `image_${idx + 1}`;

                    const fileName = `${baseName}.${ext}`;
                    zip.file(fileName, blob);
                    console.log(`Added ${fileName}`);
                } catch (e) {
                    console.error("Error adding image to zip:", e);
                }
            });

            await Promise.allSettled(promises);

            const zipBlob = await zip.generateAsync({ type: "blob" });
            const zipName = `images_backup_${moment().format("YYYYMMDD_HHmmss")}.zip`;
            saveAs(zipBlob, zipName);
        } catch (error) {
            console.error("Error creating zip:", error);
            alert("Error descargando las imágenes. Revisa la consola.");
        } finally {
            setLoading(false);
        }
    };

    const onUploadImages= async () => {
        if (!imagesOfActivities || imagesOfActivities.length === 0) return;

          try {
              setLoading(true);
             await uploadImages(imagesOfActivities);
          } catch (error) {
              console.error("Error uploading imagenes:", error);
          } finally {
              setLoading(false);
              Swal.fire({
                  // title: "The Internet?",
                  text: "Imágenes subidas con éxito.",
                  icon: "success",
              });
          }  
    }

      const onUploadSingleImage = async (image: any) => {
          if (!image) return;
          try {
              setLoading(true);
              await uploadSingleImage(image);
          } catch (error) {
              console.error("Error uploading imagenes:", error);
          } finally {
            setLoading(false);
            Swal.fire({
                // title: "The Internet?",
                text: "Imagen subida con éxito.",
                icon: "success",
            });
          }
      };

    const dataURLtoBlob = (dataurl: string): Blob => {
        const arr = dataurl.split(',');
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const downloadSingleImage = async (image: any) => {
        if (!image) return;
        setLoading(true);
        try {
            const src = getImageSrc(image);
            if (!src) return;

            let blob: Blob;
            if (src.startsWith('data:')) {
                // already data URL
                blob = dataURLtoBlob(src);
            } else {
                const resp = await fetch(src);
                if (!resp.ok) throw new Error('Failed fetching image');
                blob = await resp.blob();
            }

            const mime = blob.type || 'image/jpeg';
            const ext = mime.split('/')[1] ? mime.split('/')[1].split('+')[0] : 'jpg';
            const baseName = image.fileName
                ? image.fileName.replace(/\.[^/.]+$/, '')
                : image.location
                    ? `${image.location}_${image.counter}`
                    : `image`;
            const fileName = `${baseName}.${ext}`;

            saveAs(blob, fileName);
        } catch (e) {
            console.error('Error downloading image:', e);
            alert('Error descargando la imagen. Revisa la consola.');
        } finally {
            setLoading(false);
        }
    };

    const uploadActivities = async () => {
        let numberActivities = 0;
        try {
            setLoading(true);
            const originActivity = activities.map(a => a.originActivity);
            const response: any = await uploadActivitiesFromMobile(originActivity, vehicleOverview);
            console.log( response );
            numberActivities = response?.processRecords;
        } catch (error) {
            console.error("Error uploading activities:", error);
        } finally {
            setLoading(false);
             Swal.fire({
                 // title: "The Internet?",
                 text: `${numberActivities} actividades subidas con éxito.`,
                 icon: "success",
             });
        }
    }

    const columnsActivities: GridColDef[] = [
        { field: "id", headerName: "Id", flex: 0.6 },
        { field: "fecha", headerName: "fecha", flex: 0.6 },
        { field: "location", headerName: "Locacion", flex: 0.6 },
        { field: "estadoOpeFinal", headerName: "Estado Ope Final", flex: 0.6 },
        { field: "hora", headerName: "hora", flex: 0.6 },
        { field: "realizadaPor", headerName: "realizadaPor", flex: 0.6 },
        {
            field: "actions",
            headerName: "",
            filterable: false,
            align: "center",
            headerAlign: "center",
            flex: 0.2,
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {
                return (
                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mt: 1
                        }}
                    >
                        {/* <IconButton
                            size="small"
                            color="primary"
                            onClick={() =>{}}
                        >
                            <CloudUploadIcon fontSize="medium" />
                        </IconButton> */}
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handlePreviewActivity(params.row.id)}
                        >
                            <PageviewIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                )
            }
        }
    ]

    return (
        <>
            {loading && (
                <Grid className="loading_container_backUpMobile">
                    <Grid className="info_container">
                        <CircularProgress size="5rem" />
                        <Typography>Cargando.......</Typography>
                    </Grid>
                </Grid>
            )}
            {previewActivity && (
                <Dialog
                    open
                    onClose={handleClosePreview}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }}>
                        <Typography sx={{ fontWeight: "bold" }}>
                            Detalle de Actividad {previewActivity.location}{" "}
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleClosePreview}
                            sx={{ position: "absolute", right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Typography sx={{ mt: 1 }}>
                            <strong>Realizada Por:</strong>{" "}
                            {previewActivity.realizadaPor}
                        </Typography>

                        <Box component="pre" className="preview_info_container">
                            {previewActivity?.variables?.map((v: any) => (
                                <Grid className="preview_info_box" key={v.id}>
                                    <Typography className="preview_info_box_title">
                                        {v.name}:
                                    </Typography>
                                    <Typography className="preview_info_box_value">
                                        {v.value}
                                    </Typography>
                                </Grid>
                            ))}
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
            {previewImage && (
                <Dialog
                    open
                    onClose={handleCloseImagePreview}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }}>
                        <Typography sx={{ fontWeight: "bold" }}>
                            {previewImage.fileName ||
                                `${previewImage.location} - #${previewImage.counter}`}
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseImagePreview}
                            sx={{ position: "absolute", right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent
                        dividers
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src={getImageSrc(previewImage)}
                            alt={previewImage.fileName || "preview"}
                            style={{
                                width: "100%",
                                maxHeight: "70vh",
                                objectFit: "contain",
                                background: "#fff",
                            }}
                        />
                    </DialogContent>
                </Dialog>
            )}
            <Grid className="well_files_container_backUpMobile">
                {/* header */}
                <Grid className="header_container_well_files">
                    <IconButton
                        color="primary"
                        size="large"
                        onClick={() => handleOnGoback()}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Grid className="text_section">
                        <Typography className="title">
                            Gestion de Archivos Backup Version Mobile
                        </Typography>
                    </Grid>
                </Grid>
                {/* Body */}
                <Box className="well_files_custom_container">
                    {/* 1. Seleccionar Archivo */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                1.- Seleccione el Archivo
                            </Typography>
                            <Typography className="section_description">
                                Seleccionar el archiivo backup del mobile
                            </Typography>
                        </Grid>
                        <Grid className="left_section">
                            {file ? (
                                <Grid className="files_element">
                                    <Typography className="file_name">
                                        {file.name}
                                    </Typography>
                                    <IconButton
                                        color="error"
                                        size="large"
                                        onClick={() => handleDelteFile()}
                                    >
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </Grid>
                            ) : (
                                <Box className="file_upload_box">
                                    <IconButton component="label">
                                        <AddIcon
                                            color="primary"
                                            fontSize="large"
                                        />
                                        <input
                                            type="file"
                                            accept=".json"
                                            hidden
                                            onChange={(e) =>
                                                setFile(
                                                    e.target.files?.[0] || null
                                                )
                                            }
                                        />
                                    </IconButton>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                    {/* 2. Validar Archivo */}
                    <Grid className="section_container">
                        <Grid>
                            <Typography className="section_title">
                                2.- Leer y Validar Archivo
                            </Typography>
                        </Grid>
                        <Grid className="left_section">
                            {/* Botón Testear Archivo */}
                            <Grid className="button_container">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="custom_button"
                                    onClick={() => handleTestFile()}
                                    disabled={!file}
                                >
                                    Validar Archivo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* 3. TABS */}
                    <Grid className="tabs_state">
                        {tabs.map((t, i) => (
                            <Grid
                                className={`tab ${
                                    t.id === activeTab && "active"
                                }`}
                                key={i}
                                onClick={() => setActiveTab(t.id)}
                            >
                                <Grid>{t.name}</Grid>
                                {t.amountElement ? (
                                    <Grid
                                        className={`numberItems ${
                                            t.id === activeTab && "active"
                                        }`}
                                    >
                                        {t.amountElement}
                                    </Grid>
                                ) : null}
                            </Grid>
                        ))}
                    </Grid>

                    {/* 3.1 Activities */}
                    {activeTab === "activities" && (
                        <Grid>
                            <Grid className="download_button_container">
                                <Button
                                    onClick={uploadActivities}
                                    disabled={loading}
                                    className="download_images_button"
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {loading
                                        ? "Cargando..."
                                        : "Cargar Actividades"}
                                </Button>
                            </Grid>
                            <DataGrid
                                rows={activities}
                                columns={columnsActivities}
                                pageSizeOptions={[10, 20, 50, 100]}
                                checkboxSelection={true}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            id: false,
                                            originActivity: false,
                                        },
                                    },
                                }}
                                sx={{
                                    ...tableStyles,
                                    maxHeight: "45vh",
                                }}
                                getRowId={(row) => row.id}
                            />
                        </Grid>
                    )}

                    {/* 3.2 Images */}
                    {activeTab === "pictures" && (
                        <Grid>
                            <Grid className="download_button_container">
                                <Button
                                    onClick={onUploadImages}
                                    disabled={loading}
                                    className="download_images_button"
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                >
                                    {loading ? "Subiendo..." : "Subir Imágenes"}
                                </Button>
                                <Button
                                    onClick={onDownloadImages}
                                    disabled={loading}
                                    className="download_images_button"
                                    variant="contained"
                                    startIcon={<DownloadForOfflineIcon />}
                                >
                                    {loading
                                        ? "Descargando..."
                                        : "Descargar Imágenes"}
                                </Button>
                            </Grid>
                            {imagesOfActivities.length === 0 ? (
                                <Typography>
                                    No hay fotos disponibles.
                                </Typography>
                            ) : (
                                <Grid
                                    className="preview_info_container"
                                    sx={{
                                        marginLeft: 5,
                                        justifyContent: "space-around",
                                    }}
                                >
                                    {imagesOfActivities.map((image, index) => (
                                        <Grid
                                            className="preview_image_box"
                                            key={index}
                                        >
                                            <img
                                                src={getImageSrc(image)}
                                                alt={`Activity ${index}`}
                                                style={{
                                                    maxWidth: "200px",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                            <Typography className="preview_info_box_title">
                                                {image.location} - #
                                                {image.counter}:
                                            </Typography>
                                            <Grid>
                                                <IconButton
                                                    // size="medium"
                                                    size="large"
                                                    color="primary"
                                                    onClick={() =>
                                                        handleOpenImagePreview(
                                                            image
                                                        )
                                                    }
                                                >
                                                    <PageviewIcon fontSize="medium" />
                                                </IconButton>
                                                <IconButton
                                                    // size="medium"
                                                    size="large"
                                                    color="primary"
                                                    onClick={() =>
                                                        downloadSingleImage(
                                                            image
                                                        )
                                                    }
                                                >
                                                    <DownloadForOfflineIcon fontSize="medium" />
                                                </IconButton>
                                                <Tooltip title="Subir Imagen">
                                                    <IconButton
                                                        // size="medium"
                                                        size="large"
                                                        color="primary"
                                                        onClick={() =>
                                                            onUploadSingleImage(
                                                                image
                                                            )
                                                        }
                                                    >
                                                        <UploadIcon fontSize="medium" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            )}
                        </Grid>
                    )}

                    {/* 3.3 Vehicle Overview */}
                    {activeTab === "vehicleOverview" && (
                        <Grid
                            className="preview_info_container"
                            sx={{ marginLeft: 5 }}
                        >
                            {vehicleOverview?.variables?.map((v: any) => {
                                if (
                                    v.id ===
                                    "cada6496-956a-11f0-bbba-74d4dd58e106"
                                )
                                    return;

                                return (
                                    <Grid
                                        className="preview_info_box"
                                        key={v.id}
                                    >
                                        <Grid className="preview_info_box_title">
                                            {v.name}:
                                        </Grid>
                                        <Grid className="preview_info_box_value">
                                            {v.value || " "}
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                </Box>
            </Grid>
        </>
    );
}
